<template>
  <div class="modal-popup">
    <div class="modal fade" id="agencyPaymentListModal" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="title mt-2 ml-2">Acente Ödeme Geçmişi</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <agency-payments-list/>
          </div>

          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="theme-btn font-weight-bold font-size-15 mr-2" data-dismiss="modal" style="background-color: crimson">iptal</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AgencyPaymentsList from "./AgencyPaymentsList";
export default {
  name: "AgencyPaymentListModal",
  components: {AgencyPaymentsList},
  computed:{
  },
  methods:{
  },
  mounted() {
  },
  updated() {

  }
}
</script>

<style scoped>

</style>